module.exports = __webpack_public_path__ + "img/house24.6356cc82.svg";